import { setStore, removeStore } from '../config/mUtils'
import * as rootypes from './mutations_type'
// import FormateDate from '../plugins/formateDate'
export default {
  [rootypes.RECODE_TOKEN] (state, data) {
    state.login = true
    setStore('NameAppUserToken', data)
  },
  [rootypes.LOGOUT] (state, data) {
    state.login = false
    state.profiledata = {}
    removeStore('NameAppUserToken')
  },
  [rootypes.RECODE_MEMBERINFO] (state, data) {
    state.profiledata = data
  },
  [rootypes.FORGETPWD] (state, data) {
    state.forgetdata = data
  },


  /** Point */
  [rootypes.RECODE_POINT] (state, data) {
    state.profiledata.point = data

  },
  /** Log */
  [rootypes.RECODE_HISTORYLOG] (state, data) {
    state.historylog = data
  },
  [rootypes.PUSH_HISTORYLOG] (state, data) {
    state.historylog= state.historylog.concat(data)
  },
  [rootypes.RECODE_USELOG] (state, data) {
    state.userlog = data
  },
  [rootypes.PUSH_USELOG] (state, data) {

    state.userlog.Listdata= state.userlog.Listdata.concat(data.Listdata)
  },
  [rootypes.RECODE_PAYMENTLOG] (state, data) {
    state.purchaselog = data
  },
  [rootypes.PUSH_PAYMENTLOG] (state, data) {

    state.purchaselog= state.purchaselog.concat(data)
  },
  /** Ana */
  [rootypes.RECODE_ANARESULT] (state, data) {
    state.anaResult = data
  },
  [rootypes.RECODE_ANASUBRESULT] (state, data) {
    state.anaSubResult = data
  },
  /** Prodata */
  [rootypes.RECODE_PRODUCTDATA] (state, data) {
    state.productdata = data
  },
  /** Daily */
  [rootypes.RECODE_DAILYDATA] (state, data) {
    state.dailydata = data
  },
  /** Recode shopcart */
  [rootypes.RECODE_SHOPCART] (state, data) {
    state.shopcart = data
  },
  /** Recode order */
  [rootypes.RECODE_ORDERPURCHASE] (state, data) {
    state.orderpurchase = data
  },
  /** Recode plan */
  [rootypes.RECODE_PLAN] (state, data) {
    state.plan = data
  },
  /** Master Tips */
  [rootypes.RECODE_MASTERTIPS] (state, data) {
    state.masterTips.status = data.status
    state.masterTips.tipswords = data.tipswords
    state.masterTips.videostatus = data.videostatus
    state.masterTips.videosrc = data.videosrc
  },
  /** Updata Profile */
  [rootypes.UPDATA_PROFILE] (state, data) {
    if (data.hasOwnProperty('mail')) {
      state.profiledata.mail = data.mail
    }
    if (data.hasOwnProperty('phone')) {
      state.profiledata.phone = data.phone
    }
  },
}
